import { AddressEndPoint } from '@/modules/common/enums/end-point.ts';
import Api from '@/modules/core/api/api.ts';
import { TableId } from '@/modules/common/enums/table-id.enum.ts';
import type { Option } from '@/modules/common/types/option.type.ts';
import TypeOption from '@/modules/common/models/option/type-option.ts';
import GatewayApi from '@/modules/core/api/gateway.api.ts';
import { GatewayFilter } from '@/modules/core/utils/gateway-filter.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';

export interface AddressFormData {
  type: Option;
  address: string;
  comment: string;
}

interface AddRequest {
  parentId: number;
  formData: AddressFormData;
}

interface EditRequest {
  id: number;
  formData: AddressFormData;
}

export default class AddressApi {
  static async getTypes(signal: AbortSignal): Promise<TypeOption[]> {
    const response = await GatewayApi.execute<ItemsDto<unknown>>(AddressEndPoint.GetTypes, {
      filter: GatewayFilter.and(GatewayFilter.eq('PARENT_TABLE_ID', TableId.Counterparties)),
      signal,
    });
    return response.items.map((item: unknown) => new TypeOption(item));
  }

  static async add({ parentId, formData }: AddRequest) {
    await Api.post(AddressEndPoint.Add, {
      parent_table_id: TableId.Counterparties,
      parent_id: parentId,
      address_type: formData.type.label,
      address: formData.address,
      comment: formData.comment || undefined,
    });
  }

  static async edit({ id, formData }: EditRequest) {
    await Api.post(AddressEndPoint.Edit, {
      address_id: id,
      address_type: formData.type.label,
      address: formData.address,
      comment: formData.comment || undefined,
    });
  }

  static async delete(id: number) {
    await Api.post(AddressEndPoint.Delete, { address_id: id });
  }
}
